export const LIST_HOSTING = [
    {
        id: 'l-h-webhosting',
        text: 'Web Hosting',
        url: 'web-hosting/'
    }, {
        id: 'l-h-webhostingfull',
        text: 'Web Hosting Full',
        url: 'web-hosting-full/'
    }, {
        id: 'l-h-reseller',
        text: 'Reseller',
        url: 'reseller/'
    }
];

export const LIST_SUPPORT = [
    {
        id: 'l-h-portal-requests',
        text: 'Portal de solicitudes',
        url: 'https://haulmer.atlassian.net/servicedesk/customer/portal/1014'
    },{
        id: 'l-h-status',
        text: 'Estado de Servicios',
        url: 'https://status.livehost.host/'
    }, {
        id: 'l-h-support-tutorial',
        text: 'Video Tutoriales',
        url: 'https://www.youtube.com/channel/UC45rdxGiG11qOVCwrWKMXfQ'
    }, {
        id: 'l-h-support-doc',
        text: 'Artículos de Ayuda',
        url: 'https://docs.livehost.'
    }, {
        id: 'l-h-support-suggestions',
        text: 'Reclamos o Felicitaciones',
        url: 'https://haulmer.atlassian.net/servicedesk/customer/portal/1014/group/1050/create/1257'
    },
];

export const LIST_VPS = [
    {
        id: 'l-h-vps',
        text: 'VPS',
        url: 'ssd-vps-cloudserver/'
    }, {
        id: 'l-h-vps-backup',
        text: 'VPS + Backup',
        url: 'cloud-vps-backup/'
    }
]
